import angular from 'angular';
import DetailedPaymentComponent from './detailed-payment.component';
import DetailedPaymentService from './detailed-payment.service';
import DetailedPaymentConfig from './detailed-payment.config';
import CommentPaymentModalController from "../modal-comment-payment/modal-comment-payment.controller";

let DetailedPaymentModule = angular.module('app.payZone.detailedPayment',[])
  .component('detailedPayment', DetailedPaymentComponent)
  .service('DetailedPaymentService', DetailedPaymentService)
  .config(DetailedPaymentConfig)
  .controller('CommentPaymentModalController', CommentPaymentModalController);


export default DetailedPaymentModule;



/** WEBPACK FOOTER **
 ** C:/Bitnami/wampstack-7.1.31-0/apache2/htdocs/toning/B2C/www/components/pay-zone/detailed-payment/detailed-payment.js
 **/